import * as React from 'react';

import { CarouselOverlayPanel } from '../../components/CarouselOverlayPanel';
import { DoubleColumnLayout } from '../../components/DoubleColumnLayout';
import { FixedHeader } from '../../components/FixedHeader';
import { PageLayout } from '../../components/PageLayout';
import { PageRowLayout } from '../../components/PageRowLayout';
import { AboutContainer } from '../About';
import { AdvantagesContainer } from '../Advantages';
import { AerialViewContainer } from '../AerialView';
import { BasicInfoContainer } from '../BasicInfo';
import { BreadCrumbsContainer } from '../BreadCrumbs';
import { BuildersInfoContainer } from '../BuildersInfo';
import { CarouselContainer } from '../Carousel';
import { CompanySeoCard } from '../CompanySeoCard';
import { EscrowContainer } from '../Escrow';
import { FeaturesContainer } from '../Features';
import { ImageSources } from '../ImageSources';
import { InfrastructureContainer } from '../InfrastructureContainer';
import { InteriorDecorationContainer } from '../InteriorDecoration';
import { LabelsContainer } from '../Labels';
import { LeadFactoryCallButtonContainer } from '../LeadFactoryCallButton';
import { NewbuildingReviewsTeaserContainer } from '../NewbuildingReviewsTeaser';
import { OffersBlockContainer } from '../OffersBlock';
import { RealtyValuationContainer } from '../RealtyValuation';
import { RecommendedNewbuildingsContainer } from '../RecommendedNewbuildings';
import { RightColumnContainer } from '../RightColumn';
import { SpecificationsDetailedContainer } from '../SpecificationsDetailed';
import { OffersStatsContainer } from '../OffersStats';
import { ReliabilityV2Container } from '../ReliabilityV2';
import { LeadFactoryPromosBanner } from '../LeadFactoryPromosBanner';
import { SeoMarkedListContainer } from '../SeoMarkedList';
import { MortgageMiniCalculatorWidget } from '../MortgageMiniCalculatorWidget';

/**
 * Страница для ЖК на КпН.
 */
export const LeadFactoryPage: React.FC = () => {
  return (
    <>
      <PageLayout>
        <FixedHeader
          actionButton={<LeadFactoryCallButtonContainer placeType="blockStickyTop" size="XS" />}
          messageButton={null}
        />
        <BreadCrumbsContainer />
        <CarouselOverlayPanel />
        <CarouselContainer />

        <PageRowLayout>
          <DoubleColumnLayout
            rightColumn={<RightColumnContainer dynamicCalltrackingPlaceType="blockStickyRightTop" />}
            topContent
          >
            <LabelsContainer />
            <BasicInfoContainer />
            <OffersBlockContainer />
            <LeadFactoryPromosBanner />
            <MortgageMiniCalculatorWidget />
            <RecommendedNewbuildingsContainer />
            <AerialViewContainer />
            <RealtyValuationContainer />
            <AboutContainer />
            <AdvantagesContainer />
            <NewbuildingReviewsTeaserContainer />
          </DoubleColumnLayout>

          <InfrastructureContainer />

          <DoubleColumnLayout
            rightColumn={<RightColumnContainer dynamicCalltrackingPlaceType="blockStickyRightBottom" />}
          >
            <SpecificationsDetailedContainer />
            <InteriorDecorationContainer />
            <BuildersInfoContainer />
            <FeaturesContainer />
            <ReliabilityV2Container />
            <EscrowContainer />
            <OffersStatsContainer />
            <ImageSources />
            <SeoMarkedListContainer />
          </DoubleColumnLayout>
        </PageRowLayout>
      </PageLayout>
      <CompanySeoCard />
    </>
  );
};
